module.exports = __webpack_public_path__ + "td.svg?55acac9b3af1347c53218d8b12e52b97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/td.svg
// module id = 16
// module chunks = 0